module.exports = "/_next/static/images/banner_icon_change_skip-04b8e3d92aaa5fb8bd196be347162719.svg";